export default "__VITE_ASSET__BNJxSIQh__"